Object.defineProperty(exports, "__esModule", { value: true });
function isTesting() {
    let testing = false;
    try {
        testing = __TESTING__;
    }
    catch (_a) { }
    return testing;
}
exports.default = isTesting;
//# sourceMappingURL=isTesting.js.map